import { Model } from '@vuex-orm/core';


export default class File extends Model {
  static entity = 'files'

  static fields() {
    return {
      id: this.uid(),
      key: this.string(''),
      link: this.string(''),
    };
  }

  get name() {
    let key = this.key;

    const slash = key.lastIndexOf('/');
    if (slash > 0) {
      key = key.substring(slash + 1);
    }

    // const dot = key.lastIndexOf('.');
    // if (dot > 0) {
    //   key = key.substring(0, dot);
    // }

    return key;
  }
}
